import { makeStyles } from "@material-ui/core";

export default makeStyles(theme => ({
  dRoot: {
    alignItems: "center",
    justifyContent: "flex-start",
    padding: theme.spacing(2)
  },
  dItem: {
    flexDirection: "column",
    textAlign: "center",
    color: theme.palette.primary.main
  },
  dItemTitle: {
    fontSize: theme.typography.body2.fontSize,
    fontWeight: theme.typography.fontWeightBold
  },
  dItemNumber: {
    fontWeight: theme.typography.fontWeightMedium,
    fontFamily: "Courier Prime"
  }
}));
